import i18n from "@/i18n";

const getLocale = () => (i18n.language?.startsWith("es") ? "es-US" : "en-US");

export function formatDate(dateString) {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString(getLocale(), {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString(getLocale(), {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function timeAgo(dateString) {
  if (!dateString) return "";
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  const isEs = i18n.language?.startsWith("es");

  if (diffMins < 1) return isEs ? "Ahora" : "Just now";
  if (diffMins < 60) return isEs ? `hace ${diffMins}m` : `${diffMins}m ago`;
  if (diffHours < 24) return isEs ? `hace ${diffHours}h` : `${diffHours}h ago`;
  if (diffDays < 7) return isEs ? `hace ${diffDays}d` : `${diffDays}d ago`;
  return formatDate(dateString);
}
